import React from 'react';
import MasterLayout from './layout/MasterLayout';
import { ThemeProvider } from '@mui/material';
import { theme } from './styles/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <MasterLayout />
    </ThemeProvider>
  );
}

export default App;
